import React from "react";
import FormSelect from "../../../../components/UI/formSelect/formSelect";
import Input from "../../../../components/UI/input/GgInput";
import FileButton from "../../../../components/UI/button/FileButton";
import { AddIcon } from "../../../../assets/icons";
import { IContent, IPMBlock } from "../../../../models/IPages";
import { getImageExtensionFromBase64 } from "../../../../utils";

function ContactUs({ data, setData, articles, categoryType, actionData }: IPMBlock) {
  const handleChange = (
    index: number,
    val: string,
    type: keyof IContent
  ) => setData((prev: any) => {
    const newContent = [...prev.content];
    newContent[index][type] = val;
    if (type === "image") {
      const newImages = prev?.images || [];
      newImages[index] = val;
      const ext = getImageExtensionFromBase64(val);
      newContent[index][
        "image"
      ] = `/image/page-management/${categoryType}/contactBlock${index + 1}.${ext || "jpeg"
      }`;
      return { ...prev, images: newImages, content: newContent };
    }
    return { ...prev, content: newContent };
  });

  return (
    <>
      <div className="title">Contact Block</div>
      <div className="step-list col">
        <div className="step-item">
          <div className="step-title">Title</div>
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })} 
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-item">
          <div className="step-title">Contact Description</div>
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter Contact Description"
              value={data?.description}
              onChange={(val) => setData({ ...data, description: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="card-container-2">
          <div className="step-item">
            <div className="step-title">Number Block</div>
            <div className="card">
              <FileButton
                index={0}
                icon={{
                  leftIcon: <AddIcon size="18" className="icon" />,
                }}
                value={data?.content[0]?.image}
                stylesType="border"
                onChange={(val) => handleChange(0, val, 'image',)}
                className="cover-image-button"
                disabled={!actionData?.edit}
              />
              <Input
                type="text"
                placeholder="Enter Contact Number"
                label="Contact Number"
                value={data?.content[0]?.heading}
                onChange={(val) => handleChange(0, val, 'heading')}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="step-title">SMS Block</div>
            <div className="card">
              <FileButton
                index={1}
                icon={{
                  leftIcon: <AddIcon size="18" className="icon" />,
                }}
                value={data?.content[1]?.image}
                stylesType="border"
                onChange={(val) => { handleChange(1, val, 'image') }}
                className="cover-image-button"
                disabled={!actionData?.edit}
              />
              <Input
                type="text"
                placeholder="SMS"
                label="SMS"
                value={data?.content[1]?.heading}
                onChange={(val) => { handleChange(1, val, 'heading') }}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="step-title">Book an appointment Block</div>
            <div className="card">
              <FileButton
                index={2}
                icon={{
                  leftIcon: <AddIcon size="18" className="icon" />,
                }}
                value={data?.content[2]?.image}
                stylesType="border"
                onChange={(val) => {
                  handleChange(2, val, 'image')
                }}
                className="cover-image-button"
                disabled={!actionData?.edit}

              />
              <Input
                type="text"
                placeholder="Enter Book an appointment"
                label="Book an appointment"
                value={data?.content[2]?.heading}
                onChange={(val) => { handleChange(2, val, 'heading') }}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="step-title">Email Block</div>
            <div className="card">
              <FileButton
                index={3}
                icon={{
                  leftIcon: <AddIcon size="18" className="icon" />,
                }}
                value={data?.content[3]?.image}
                stylesType="border"
                onChange={(val) => handleChange(3, val, 'image')}
                className="cover-image-button"
                disabled={!actionData?.edit}
              />
              <Input
                type="text"
                placeholder="Enter Email"
                label="Email"
                value={data?.content[3]?.heading}
                onChange={(val) => { handleChange(3, val, 'heading') }}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
